import { render, staticRenderFns } from "./BiddingAttachment.vue?vue&type=template&id=7edc7be6&"
import script from "./BiddingAttachment.vue?vue&type=script&lang=js&"
export * from "./BiddingAttachment.vue?vue&type=script&lang=js&"
import style0 from "./BiddingAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports